module.exports = __webpack_public_path__ + "static/media/sh.6d795741.png";